import { StyledSVG, StyledPath } from './Styled'

const ReasonToHireMeCTAIcon = () => (
  <StyledSVG
    display={{ _: 'none', tablet: 'inherit' }}
    width='64px'
    height='64px'
    viewBox='0 0 64 64'
    fill='none'
    xmlns='http://www.w3.org/2000/svg'
  >
    <circle cx='32' cy='32' r='32' fill='white' />
    <StyledPath d='M45.1667 52C46.6996 52 48.1979 51.5455 49.4724 50.6939C50.7469 49.8423 51.7402 48.6319 52.3268 47.2158C52.9134 45.7997 53.0669 44.2414 52.7678 42.738C52.4688 41.2347 51.7307 39.8538 50.6468 38.7699C49.563 37.6861 48.1821 36.9479 46.6787 36.6489C45.1753 36.3499 43.6171 36.5034 42.201 37.0899C40.7848 37.6765 39.5744 38.6698 38.7229 39.9443C37.8713 41.2188 37.4167 42.7172 37.4167 44.25C37.4212 46.3041 38.2391 48.2728 39.6915 49.7252C41.144 51.1777 43.1127 51.9956 45.1667 52Z' />
    <path
      d='M16.7166 46.2667C16.7183 43.2831 17.5858 40.3642 19.2138 37.8639C20.8417 35.3636 23.1602 33.3895 25.888 32.1808C28.6158 30.9722 31.6357 30.5811 34.5814 31.0549C37.5271 31.5286 40.272 32.847 42.4832 34.85'
      stroke='#3B3B3E'
      strokeWidth='1.35'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <path
      d='M32.1332 30.0667C36.7816 30.0667 40.5499 26.2984 40.5499 21.65C40.5499 17.0016 36.7816 13.2333 32.1332 13.2333C27.4848 13.2333 23.7166 17.0016 23.7166 21.65C23.7166 26.2984 27.4848 30.0667 32.1332 30.0667Z'
      stroke='#3B3B3E'
      strokeWidth='1.35'
      strokeMiterlimit='10'
    />
    <path
      d='M48.9999 41.9333L43.9833 46.9333L41.0833 44.0333'
      stroke='#3B3B3E'
      strokeMiterlimit='10'
      strokeLinecap='round'
    />
    <StyledPath d='M17.1667 20.3333C17.9859 18.4725 19.4725 16.9859 21.3333 16.1667C19.4687 15.3529 17.9804 13.8646 17.1667 12C16.3474 13.8609 14.8609 15.3474 13 16.1667C14.8609 16.9859 16.3474 18.4725 17.1667 20.3333Z' />
  </StyledSVG>
)

export default ReasonToHireMeCTAIcon
